import { ReactComponent as Close } from "./close.svg";
import { SvgIcon } from "@material-ui/core";

export default function CloseButton(props) {
  return <SvgIcon {...props} component={Close} viewBox="0 0 16 16" />;
}
